import React from 'react'

export default function MusicQuote({ className }) {
  return (
    <svg viewBox="0 0 25 25" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M22.634 17.87l1.211 3.419c.263.743.152 1.608-.402 2.167a2.172 2.172 0 01-.555.407c-.464.238-1.017.228-1.514.071l-3.716-1.172-.001-.008a11.81 11.81 0 01-5.479 1.346C5.609 24.1.284 18.768.284 12.19S5.609.279 12.178.279c6.568 0 11.893 5.333 11.893 11.911a11.88 11.88 0 01-1.437 5.68zm-7.67-2.531V4.264l-5.47 2.277v3.405l3.694-1.538v4.462a2.947 2.947 0 00-1.476-.037c-1.797.405-3.254 2.193-3.254 3.992 0 1.8 1.457 2.931 3.254 2.526 1.723-.389 3.119-2.048 3.232-3.771h.02v-.201l.002-.021-.002-.019z"
      />
    </svg>
  )
}
